export default {
  footer: {
    tagline: 'AI-powered delivery management platform that helps businesses automate dispatch, optimize routes, and delight customers.',
    aiCommandHint:
      'AI Command Centre: autonomous carrier & driver allocation, agentic route planning, smart alerts & AI Agents—one control tower.',
    product: 'Product',
    builtFor: 'Built For',
    resources: 'Resources',
    company: 'Company',
    compare: 'Compare',
    links: {
      compareHub: 'Compare all platforms',
      howItWorks: 'How it works',
      brandedTracking: 'Branded Tracking',
      routePlanner: 'Route Planner',
      aiAgents: 'AI Agents',
      autoAllocation: 'Auto Allocation',
      driverApp: 'Driver App',
      cashManagement: 'Cash Management',
      proofOfDelivery: 'Proof of Delivery',
      reportsAnalytics: 'Reports & Analytics',
      restaurants: 'Restaurants & QSR',
      pharmacies: 'Pharmacies',
      retail: 'Retail',
      ecommerce: 'E-commerce',
      couriers: 'Couriers & Logistics',
      grocery: 'Grocery & Supermarkets',
      allIndustries: 'All industries',
      caseStudies: 'Case Studies',
      blog: 'Blog',
      roiCalculator: 'ROI calculator',
      whitepapers: 'Whitepapers',
      aboutUs: 'About Us',
      pricing: 'Pricing',
      partners: 'Partners',
      integrations: 'Integrations',
      contact: 'Contact',
      altRoutific: 'Routific alternative',
      altShipday: 'Shipday alternative',
      altOnfleet: 'Onfleet alternative',
      altTookan: 'Tookan alternative',
      altCircuit: 'Circuit alternative',
      altOptimoroute: 'OptimoRoute alternative',
      altRoute4me: 'Route4Me alternative',
      altBringg: 'Bringg alternative',
      altDetrack: 'Detrack alternative',
      altLocus: 'Locus alternative',
      altDispatchtrack: 'DispatchTrack alternative',
      altTrackPod: 'Track-POD alternative',
      altUpper: 'Upper alternative',
      altZeo: 'Zeo alternative',
    },
    language: 'Language',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    rights: 'All rights reserved.',
    location: { title: 'Our location', eyebrow: 'Headquarters', hq: 'Geofleet HQ', cta: 'Open in Maps', contact: 'Contact us' },
  },
};
